exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1E2C-eIA6-8TRyOwDSm3L9 {\n  padding: 2rem;\n  display: flex;\n  flex-flow: row wrap;\n}\n.EPovoASTGJd0mWuWa1UNq {\n  margin-right: 1rem;\n  margin-bottom: 1rem;\n}\n._24TRU1cdi6eOg6D7n7GJGL {\n  background: linear-gradient(to bottom, transparent 0, #fff 10px);\n  bottom: 0;\n  color: #333;\n  font-size: 0.8rem;\n  max-height: 6rem;\n  overflow: hidden;\n  padding: 0.8rem 0.5rem 0.5rem 0;\n  position: absolute;\n}\n", ""]);

// exports
exports.locals = {
	"game-list": "_1E2C-eIA6-8TRyOwDSm3L9",
	"game": "EPovoASTGJd0mWuWa1UNq",
	"player-names": "_24TRU1cdi6eOg6D7n7GJGL"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/stylus-loader!./src/css/game-list.styl
 ** module id = 256
 ** module chunks = 0
 **/